import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { companyImage } from '@/utils/common/env.constants';
import { Button, Typography } from '@pwskills/rachnaui';
import React, { useContext, useState } from 'react';
import LeadCapture from '../../common/LeadCapture';
import { LeadCaptureEnquiryType, LeadCaptureType } from '../../../interfaces/leadCapture.enum';

const CompanyList = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { placementCompanies } = courseDetails?.courseMetaDetails || {};
  const [openModal, setOpenModal] = useState(false);
  return (
    <div className="flex flex-col justify-center items-center pt-4 pb-14">
      <div className="grid grid-cols-2 medium:grid-cols-4 regular:grid-cols-5 large:grid-cols-7 last:col-span-[1/span 2]  gap-x-[16px] gap-y-[20px] regular:gap-x-[24px] regular:gap-y-[25px] items-center justify-between flex-grow-0 !pt-[46px] pb-[56px]  border-t-4 border-yellow-200 relative achievers">
        <Typography
          component="h4"
          variant="bold"
          className="absolute -top-0.5 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-blue-50 px-2 py-2 regular:!px-4 regular:!py-3 !text-[#543D11] text-center regular:!text-left whitespace-nowrap"
        >
          Our Alumni&apos;s Are Placed At
        </Typography>
        {placementCompanies?.map((company) => (
          <figure
            className="shrink-0 flex justify-center items-center bg-white py-3 px-9 z-[1]"
            key={company._id}
          >
            <img
              src={`${companyImage}/company_logos/${company?.companyLogoFileName}`}
              alt={company?.name}
              width={125}
              height={32}
              className="h-8 medium:!h-9 regular:!h-10 large:!h-12 aspect-[3/2] medium:!aspect-[5/2] object-contain"
            />
          </figure>
        ))}
      </div>
      <Button className="px-7 py-4 !w-fit" onClick={() => setOpenModal(true)}>
        Connect with Our Alumni
      </Button>
      {openModal && (
        <LeadCapture
          leadCaptureType={LeadCaptureType.MODAL}
          courseId={courseDetails?._id}
          modelOpen={openModal}
          setModelOpen={setOpenModal}
          buttonText="Get Connected"
          img="/images/courseDescription/get-in-touch.svg"
          msgLineOne="We Got Your Response."
          msgLineTwo="Our Counsellor will reach out soon"
          type="ConnectWithCounsellor"
          enquiryType={LeadCaptureEnquiryType.TALK_TO_OUR_ALUMNI}
          enquiryTypeNPF="Talk To Our Alumni"
          pageName="course_description"
          sourceName="course_description_our_achievers"
        />
      )}
    </div>
  );
};

export default CompanyList;
